import { render, staticRenderFns } from "./ImagePhotoJourneyHistory.vue?vue&type=template&id=6069237a"
import script from "./ImagePhotoJourneyHistory.vue?vue&type=script&lang=js"
export * from "./ImagePhotoJourneyHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports